
$(function(){
// 获取当前语言
  let language = {
    es: {
      pic: "https://cdn.shopifycdn.net/s/files/1/0505/9661/0199/files/4.png?v=1606204289",
      text: "Español"
    },
    it: {
      pic: "https://cdn.shopify.com/s/files/1/0505/9661/0199/files/it.jpg?v=1629182219",
      text: "Italiano"
    },
    fr: {
      pic: "https://cdn.shopify.com/s/files/1/0505/9661/0199/files/fr.jpg?v=1629182219",
      text: "Français"
    }
  }
  
  let history = document.referrer;
  let langs = navigator.language;
  let path = location.pathname;
  let langArr = ['/es','/it'];
  let res = langArr.find(item=>{
    return path.includes(item)
  })
  res ? localStorage.setItem('lang',res) : localStorage.setItem('lang','')
  if(!history && !history.includes('turboant')){
    if(langs !== 'fr' && (langs == 'es' || langs == 'it')){
      location.href = '/' + langs + path;
    }
  }
  if(path.includes('/es')){
    getLanguage(language.es.pic,language.es.text)
  }else if(path.includes('/it')){
    getLanguage(language.it.pic,language.it.text)
  }else{
    getLanguage(language.fr.pic,language.fr.text)
  }
})

$(function () {
  // 首页banner
  var indexSwiper = new Swiper('.top-banner', {
    autoplay: true,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  var indexSwiper = new Swiper('.bottom-banner', {
    autoplay: true,
  })

  // 首页小banner
  var waterfallSwiper = new Swiper('.waterfall-content', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  // show
  var showSwiper = null;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    showSwiper = new Swiper('.waterfall .swiper-container', {
      slidesPerView: 'auto',
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
      }
    });
  } else {
    showSwiper = new Swiper('.waterfall .swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: 2,
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });
  }
  var introduceSwiper = new Swiper('.introduce .swiper-container', {
    slidesPerView: 'auto',
    spaceBetween: 70,
    loop: true,
    autoplay: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  var galleryThumbs = new Swiper('.featured-product .gallery-thumbs', {
    spaceBetween: 40,
    slidesPerView: 'auto',
    freeMode: true,
    direction: 'vertical',
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    virtualTranslate: true
  });
  var galleryTop = new Swiper('.featured-product .gallery-top', {
    // autoplay:true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });

  var t1Swiper = new Swiper('.t1-picture', {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    autoplay: true,
    loopedSlides: 5,
    autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      //clickable :true,
    },
    on: {
      progress: function (progress) {
        for (i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i);
          var slideProgress = this.slides[i].progress;
          modify = 1;
          if (Math.abs(slideProgress) > 1) {
            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
          }
          translate = slideProgress * modify * 260 + 'px';
          scale = 1 - Math.abs(slideProgress) / 5;
          zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
          slide.transform('translateX(' + translate + ') scale(' + scale + ')');
          slide.css('zIndex', zIndex);
          slide.css('opacity', 1);
          if (Math.abs(slideProgress) > 3) {
            slide.css('opacity', 0);
          }
        }
      },
      setTransition: function (transition) {
        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i)
          slide.transition(transition);
        }
      },
      slideChangeTransitionEnd: function () {
        let activeImg = $('.t1-picture .swiper-slide-active img').attr('src');
        let wapImg = $('.t1-picture .swiper-slide-active img').data('wap');
        if (isPhone === 'wap') {
          $('.details-banner7 .picture-bg').attr('src', wapImg)
        } else {
          $('.details-banner7 .picture-bg').attr('src', activeImg)
        }
      },
    }
  });
  var s1Swiper = new Swiper('.s1-picture', {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    autoplay: true,
    loopedSlides: 5,
    autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      //clickable :true,
    },
    on: {
      progress: function (progress) {
        for (i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i);
          var slideProgress = this.slides[i].progress;
          modify = 1;
          if (Math.abs(slideProgress) > 1) {
            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
          }
          translate = slideProgress * modify * 260 + 'px';
          scale = 1 - Math.abs(slideProgress) / 5;
          zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
          slide.transform('translateX(' + translate + ') scale(' + scale + ')');
          slide.css('zIndex', zIndex);
          slide.css('opacity', 1);
          if (Math.abs(slideProgress) > 3) {
            slide.css('opacity', 0);
          }
        }
      },
      setTransition: function (transition) {
        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i)
          slide.transition(transition);
        }
      },
      slideChangeTransitionEnd: function () {
        let activeImg = $('.s1-picture .swiper-slide-active img').attr('src');
        let wapImg = $('.s1-picture .swiper-slide-active img').data('wap');
        if (isPhone === 'wap') {
          $('.details-banner7 .picture-bg').attr('src', wapImg)
        } else {
          $('.details-banner7 .picture-bg').attr('src', activeImg)
        }
      },
    }
  });
  var productThumbs = new Swiper('#product-thumbnails', {
    spaceBetween: 20,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  var bikeSwiper = new Swiper('.bike-show', {
    autoplay: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  var topEl = document.querySelector('.bike-show');
  if (topEl) {
    topEl.onmouseenter = function () {
      bikeSwiper.autoplay.stop();
    };
    topEl.onmouseleave = function () {
      bikeSwiper.autoplay.start();
    }
  }


  let topObj = null;
  if (document.querySelector('#product-thumbnails')) {
    topObj = {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: productThumbs
      },
      on: {
        init: function (swiper) {
          let variantId = document.getElementById('variantId').value;
          let current = document.getElementById('variantId').getAttribute('data-first');
          if (variantId === '40707801219223') {
            this.slideTo(1, 1000, false);
          } else if (variantId === '40707801284759') {
            this.slideTo(2, 1000, false);
          }
        }
      }
    }
  } else {
    topObj = {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }
  }
  var productTop = new Swiper('#product-photos', topObj);
  var topProduct = new Swiper('.r1-top-product-show', {
    slidesPerView: isPhone == 'web' ? 'auto' : 1.1,
    spaceBetween: isPhone == 'web' ? 25 : 25,
    loop: true,
    speed: 8000,
    freeMode: true,
    autoplay: {
      pauseOnMouseEnter: true,
    },
  });


  var topProduct = new Swiper('.top-product-show', {
    slidesPerView: 'auto',
    spaceBetween: isPhone == 'web' ? 25 : 5,
    loop: true,
    freeMode: true,
    speed: 8000,
    autoplay: {
      disableOnInteraction: false,
      delay: 0
    },
  });

  if (topProduct.el != undefined && isPhone == 'web') {
    topProduct.el.onmouseover = function () {
      topProduct.autoplay.stop();
    }
    topProduct.el.onmouseout = function () {
      topProduct.autoplay.start();
    }
  }

  // var topEl = document.querySelector('.top-product-show');
  // topEl.onmouseenter = function () {
  //   topProduct.autoplay.stop();
  // };
  // topEl.onmouseleave = function () {
  //   topProduct.autoplay.start();
  // }


  var topProduct = new Swiper('.s1-top-product-show', {
    slidesPerView: isPhone == 'web' ? 'auto' : 1.3,
    spaceBetween: isPhone == 'web' ? 25 : 5,
    loop: true,
    speed: 8000,
    freeMode: true,
    autoplay: {
      pauseOnMouseEnter: true,
    },
  });

  var bottomProduct = new Swiper('.bottom-product-show', {
    slidesPerView: 'auto',
    spaceBetween: isPhone == 'web' ? 25 : 5,
    freeMode: true,
    loop: true,
    speed: 8000,
    autoplay: {
      disableOnInteraction: false,
      delay: 0
    },
  });

  var m1Swiper = new Swiper('.m1-feature-list', {
    slidesPerView: isPhone == 'web' ? 3 : 'auto',
    spaceBetween: isPhone == 'web' ? 20 : 10,
    watchOverflow: isPhone === 'web' ? true : false,
    loop: isPhone == 'web' ? false : true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  var cbike = new Swiper('.cbike-swiper', {
    loop:true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  let compareWeb = {
    slidesPerView: 4,
    spaceBetween: 14,
    watchOverflow: true,
  }
  let compareWap = {
    slidesPerView: 3,
    spaceBetween: 13,
	  centeredSlides: true,
	  loop: true,
    slideToClickedSlide: true,
    on:{
      slideChangeTransitionEnd: function(){
        console.log(this.realIndex);
        let index = this.realIndex;
        $('.cbike-info-item').eq(index).show().siblings().hide();
        console.log($('.cbike-params table td').eq(index + 1))
        let tr = document.querySelectorAll('.cbike-params-tr');
        tr && tr.forEach(item=>{
          $(item).find('td').eq(index + 1).show().siblings().hide()
        })
      },
    }
  }

  var cbikeCompare = new Swiper('.cbike-product', isPhone === 'web' ? compareWeb : compareWap);

  var cbikeReview = new Swiper('.cbike-review-swiper',{
    autoplay:true,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });


  $('.readMore').click(function(){
    $(this).parent().prev().toggleClass('overflow');
    $(this).toggleClass('active')
    if($(this).hasClass('active')){
      $(this).find('span').text("Read Less")
    }else{
      $(this).find('span').text("Learn More")
    }
  })

  $('.cbike-params-btn').click(function(){
    $(this).prev().toggleClass('overflow');
    $(this).toggleClass('active')
    if($(this).hasClass('active')){
      $(this).find('span').text("Read Less")
    }else{
      $(this).find('span').text("Learn More")
    }
  })
  let history = document.referrer;
  let langs = navigator.language;
  let path = location.pathname;
  if (!history && !history.includes('turboant')) {
    if (langs !== 'en' && langs !== 'fr' && (langs == 'es' || langs == 'it')) {
      location.href = '/' + langs + path;
    } else if (langs === 'fr') {
      location.href = 'https://turboant-fr.myshopify.com/'
    }
  }
  // 切换header背景颜色
  getScrollTop();
  $(document).scroll(function () {
    getScrollTop();
  })
  $('#header-account').click(function () {
    $(this).find('.icon-user').toggleClass('on');
    $(this).find('.account-dropdown').toggleClass('on');
  });
  
// 切换移动端导航栏显示隐藏
$('#navToggle').click(function () {
  if ($(this).hasClass('on')) {
    $(this).removeClass('on');
    $('.icon-guanbi').hide();
    $('.icon-caidan').show();
    $('body').css('overflow', 'inherit')
    $('.m-mobile-navigation').slideUp();
  } else {
    $(this).addClass('on');
    $('.icon-caidan').hide();
    $('.icon-guanbi').show();
    $('body').css('overflow', 'hidden')
    $('.m-mobile-navigation').slideDown();
  }
})

$('.m-nav-list li>a').click(function () {
  $(this).parent().toggleClass('active')
  $(this).parent().siblings().removeClass('active');
  $(this).parent().siblings().find('.m-product-box').slideUp();
  $(this).parent().siblings().find('.m-nav-dropdown').slideUp();
  $(this).next().slideToggle();
})
  // 替换移动端轮播
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    $('.th_product_title').attr('colspan', 3) //切换购物车th行宽
  }
  // 切换购物车显示隐藏
  $('#headerCart').click(function () {
    $('.popup-cart').addClass('on');
  });
  $('.popup-cart-close').click(function () {
    $('.popup-cart').removeClass('on');
  });
  // 产品详情页定时器
  /*
  if (screen.width > 798) {
    $('#product_countdown').timeTo({
      timeTo: new Date('2020-12-20T18:00:00.000Z'),
      displayDays: 2,
      theme: "black",
      displayCaptions: true,
      fontSize: 48,
      captionSize: 14,
      lang: 'en',
      countdown: true
    });
  } else {
    $('#product_countdown').timeTo({
      timeTo: new Date('2020-12-20T18:00:00.000Z'),
      displayDays: 2,
      theme: "black",
      displayCaptions: true,
      fontSize: 36,
      captionSize: 14,
      lang: 'en',
      countdown: true
    });
  }
  */
  //产品详情页tab切换
  $(window).scroll(function (event) {
    var scrollTop = $("html").scrollTop(); //获取当前位置到页面顶部的距离
    $(".nav-tabs li a").each(function (index, element) { //遍历导航栏选项
      if ($(element.hash).offset() && scrollTop >= $(element.hash).offset().top - 250) { //判断当前位置是否为导航栏对应区域
        $(this).parent().addClass('active'); //将导航栏选项设置样式
        $(this).parent().siblings().removeClass('active'); //将其他导航选项取消样式
      };
    });
  });
  $('.nav-tabs li').click(function () {
    $(this).addClass('active').siblings().removeClass('active');
    let id = $(this).find('a').attr('href');
    let type = $(this).find('a').data('type');
    let num = 150;
    $(`${id}`).addClass('active').siblings().removeClass('active');
    $('html,body').animate({
      scrollTop: $(id).offset().top - num
    }, 0);
  })



  // 头部shopnow 按钮显示隐藏
  let pathname = window.location.pathname;
  if (pathname.indexOf('pages') > -1 && pathname.indexOf('x7') > -1) {
    if (pathname.indexOf('x7-pro-electric-scooter') > -1) {
      $('.shop-btn').attr('href', '/products/turboant-x7-pro-electric-scooter-g-11')
    } else if (pathname.indexOf('x7-electric-scooter-battery') > -1) {
      $('.shop-btn').attr('href', '/products/replacement-battery-for-x7-folding-electric-scooter-g-2');

    } else if (pathname.indexOf('x7-electric-scooter') > -1) {
      $('.shop-btn').attr('href', '/products/turboant-x7-folding-electric-scooter-g-1');

    }
    $('.shop-btn').show();
  }

  $('.header-language .current').click(function () {
    $(this).next().toggleClass('on');
  });
  // 语言切换
 $('.language-list li').click(function () {
    let type = $(this).data('type');
    let pathname = location.pathname;
    let replace;
    if (pathname.includes('/es')) {
      replace = pathname.replace('/es', '')
    } else if (pathname.includes('/it')) {
      replace = pathname.replace('/it', '')
    } else {
      replace = pathname;
    }
    if (type != 'en') {
      if (type == 'fr') {
        return window.location.href = `https://turboant-fr.myshopify.com${replace || ''}`
      }
      window.location.href = `/${type}${replace || ''}`
    } else {
      location.href = 'https://turboant.myshopify.com/'
    }
  })

  $('.product-buyit').click(function () {
    if ($('.shopify-payment-button__button')) {
      $('.shopify-payment-button__button').click();
    } else {
      $('html,body').animate({
        scrollTop: 0
      });
    }
  })
  $('.icon-fix-close').click(function (e) {
    e.stopPropagation();
    sessionStorage.setItem('fixStatus', 1)
    $('.fixed-banner').hide();
  });
  window.onload = function () {
    var status = sessionStorage.getItem('fixStatus');
    status == 1 && $('.fixed-banner').hide();

    if (window.location.pathname.indexOf('mothers-day-sale') > -1) {
      $('.fixed-banner').hide();
    }
  }
  $('.mobile-nav__item').click(function () {
    if ($('.nav-links-list-lv2').hasClass('on')) {
      $(this).find('button').addClass('on');
    } else {
      $(this).find('button').removeClass('on')
    }
  })
  $('.bike-attrs-box li a,.details-configs li a').click(function () {
    let id = $(this).attr('href');
    $("html,body").animate({
      scrollTop: $(id).offset().top
    }, 1000);

  })
  if (isPhone == 'web') {
    $(".product-show-picture").imagezoomsl({
      zoomrange: [2, 2],
      magnifiereffectanimate: "fadeIn",
      zindex: '99',
      cursorshadeborder: '1px solid #000',
    });
  }
  $('.service-tabs li').click(function () {
    $(this).addClass('active').siblings().removeClass('active');
    $('.service-tab-column').removeClass('active')
    $('.service-tab-column').eq($(this).index()).addClass('active')
  });

  $('.collapse-box li .collapse-title').click(function () {
    $(this).parent('li').toggleClass('active');
  })

  // 切换自行车 S1 T1
  let variantId = document.getElementById('variantId') && document.getElementById('variantId').value;
  if (variantId === '40707801284759') {
    let toggleImg = document.querySelectorAll('.toggleImg');
    toggleImg.forEach(item => {
      console.log(item)
      let s1Img = item.getAttribute('data-s1');
      item.setAttribute('src', s1Img)
    })
  }
});

let $window = $(window),
  win_height_padded = $window.height() * 1,
  // win_height_padded = $window.height(),
  isTouch = Modernizr.touch;
$(window).on('scroll', revealOnScroll);

function revealOnScroll() {
  let scrolled = $window.scrollTop();
  $('.revealOnScroll:not(.animated)').each(function () {
    let $this = $(this);
    offsetTop = $this.offset().top;
    if (scrolled + win_height_padded > offsetTop) {
      if ($this.data('timeout')) {
        window.setTimeout(function () {
          $this.addClass(`animated ${$this.data('animation')}`)
        }, parseInt($this.data('timeout')), 10)
      } else {
        $this.addClass(`animated ${$this.data('animation')}`)
      }
    }
  })
}


function getScrollTop() {
  let scrollTop = $(window).scrollTop();
  if (scrollTop > 100) {
    $('.site-header').addClass('head-fixed')
  } else {
    $('.site-header').removeClass('head-fixed')
  }
  if (scrollTop > 3200) {
    $('.ab-icon.move').addClass('active');
    $('.ab-icon.movetxt').addClass('active')
  }
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    if (scrollTop > 1000) {
      $('.product-buyit').show();
    } else {
      $('.product-buyit').hide();
    }
  };
}
window.onscroll = function () {
  $(window).scrollTop() > 1200 ? $('#back-to-top').show() : $('#back-to-top').hide();
  $(window).scrollTop() > 1200 ? $('.nav-wrap .add-btn').show() : $('.nav-wrap .add-btn').hide()
  
  if(isPhone === 'web'){
    $(window).scrollTop() > 1700 ? $('.cbike-compare').addClass('scale') : $('.cbike-compare').removeClass('scale')
  }
}
document.querySelector('#back-to-top').addEventListener('click', function () {
  $('html').animate({
    scrollTop: 0
  }, 500)
})
$('.nav-wrap .add-btn').click(function () {
  $('.product-form__cart-submit').click();
})

// 取消订单表单
let orderCancel = document.querySelectorAll('.cancel-btn'),
  orderBox = document.querySelector('.order-form'),
  layer = document.querySelector('.order-layer'),
  emailText = document.querySelector('#orderEmail'),
  IdText = document.querySelector('#orderId'),
  nameText = document.querySelector('#userName'),
  cancelSuccess = document.querySelector('.cancel-success'),
  returnSuccess = document.querySelector('.return-success'),
  orderType = document.querySelector('#orderType'),
  accountEmail = document.querySelector('#accountEmail') && document.querySelector('#accountEmail').value,
  urlName = location.pathname,
  timer;

$(function () {
  const reasons = {
    'returnReq': ['Ordered by mistake', 'Item damaged or defective', 'No longer needed', 'Other'],
    'cancelReq': ['Ordered by mistake', 'Entered wrong information', 'No longer needed', 'Others']
  };
  // 判断当前订单是否已申请
  if (urlName.includes('account')) {
    $.ajax({
      type: "post",
      url: "https://synck3cloud.anshismart.com/ship/interface/getshopifyrefundorders",
      data: {
        site: 'https://turboant.com',
        user_email: accountEmail
      },
      dataType: "json",
      success: function (response) {
        if (response.status === 1) {
          const {
            data
          } = response;
          let newData = [];
          data.forEach(item => {
            let ind = newData.findIndex(val => val.order === item.order)
            if (ind <= -1) {
              newData.push(item)
            } else if (item.type === 2) {
              newData.splice(ind, 1, item)
            }
          })
          let tr = document.querySelectorAll('.responsive-table tbody tr');
          tr.forEach((item) => {
            const key = item.dataset.key;
            let i = newData.findIndex(val => val.order === key);
            if (i >= 0) {
              newData[i].type === 1 ? item.querySelector('.refund').setAttribute('disabled', true) : item.querySelector('.return').setAttribute('disabled', true)
            }
          })
        }
      }
    });
  }
  orderCancel.forEach(item => {
    item.addEventListener('click', function () {
      let orderId = this.getAttribute('date-orderId'),
        userEmail = this.getAttribute('date-userEmail'),
        userName = this.getAttribute('data-name'),
        status = this.getAttribute('data-status'),
        li = '';
      console.log(status)
      if (status == 1) {
        console.log(status)
        cancelSuccess.style.display = 'block'
        reasons.cancelReq.forEach(item => {
          li += `<option value="${item}">${item}</option>`
        })
      } else {
        returnSuccess.style.display = 'block'
        reasons.returnReq.forEach(item => {
          li += `<option value="${item}">${item}</option>`
        })
      };
      document.querySelector('.reason-option').innerHTML = li
      orderBox.classList.add('show');
      layer.style.display = 'block';
      document.querySelector('body').style.overflow = 'hidden';
      emailText.value = userEmail;
      IdText.value = orderId;
      nameText.value = userName;
      orderType.value = status;
      item.setAttribute('disabled', true)
      timer = setTimeout(() => {
        item.removeAttribute('disabled')
        clearTimeout(timer)
      }, 10000)
    })
  })


  layer && layer.addEventListener('click', function () {
    closeOrderBox()
  })

  let submitCancel = document.querySelector('#requestBtn');
  let resultBox = document.querySelector('.order-result');
  submitCancel && submitCancel.addEventListener('click', function (e) {
    e.preventDefault();
    let data = $('#orderForm').serialize();
    if (nameText !== '') {
      $.ajax({
        type: "post",
        url: "https://synck3cloud.anshismart.com/ship/interface/applyshopifyrefund",
        data: data,
        dataType: "json",
        success: function (response) {
          if (response.status === 1) {
            resultBox.classList.add('show');
            layer.style.display = 'block';
            orderBox.classList.remove('show');
            document.querySelector('body').style.overflow = 'auto';
          } else {
            alert(response.msg)
          }
        }
      });
    }
  });
  let klarnaIcon = document.querySelector('.klarna-info');
  let klarnaModal = document.querySelector('#shopify-section-klarna-modal')
  let klarnClose = document.querySelector('.klarna-close');
  klarnaIcon && klarnaIcon.addEventListener('click', function () {
    klarnaModal.style.display = 'flex'
  })

  klarnClose && klarnClose.addEventListener('click', function () {
    klarnaModal.style.display = 'none'
  })
  $(document).on('click', '.ryviu-item', function () {
    $('.nav-tabs li').eq(3).addClass('active').siblings().removeClass('active');
    $('.product-tabs-main .product-tabs-item').eq(3).addClass('active').siblings().removeClass('active')
  })

  function closeOrderBox() {
    layer.style.display = 'none';
    orderBox && orderBox.classList.remove('show');
    resultBox && resultBox.classList.remove('show');
    document.querySelector('body').style.overflow = 'auto';
  }

})

function getFormObj(Str, Obj) {
  for (let i in Str) {
    Obj[Str[i].name] = Str[i].value;
  }
  return Obj;
}




var r1SlideSwiper = new Swiper('.r1-slide-content', {
  slidesPerView: isPhone == 'web' ? 1.57 : 1,
  speed: 1000,

  spaceBetween: 60,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.news-slider-next',
    prevEl: '.news-slider-prev'
  },

  on: {

    init: function (swiper) {
      this.$el.find('.swiper-slide-active .r1-slide-sub-box').addClass('active');
      this.$el.find('.swiper-slide-active h3').addClass('active');
    },
    slideNextTransitionStart: function (swiper) {

    },
    slideChangeTransitionEnd: function () {
      this.slides.find('.r1-slide-sub-box').removeClass('active');
      this.slides.find('h3').removeClass('active');
      this.slides.eq(this.activeIndex).find('.r1-slide-sub-box').addClass('active');
      this.slides.eq(this.activeIndex).find('h3').addClass('active');
    },

  },

});


var r1SlideSwiper2 = new Swiper('.r1-slide-content2', {
  slidesPerView: isPhone == 'web' ? 1.57 : 1,
  speed: 1000,
  spaceBetween: 60,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.news-slider-next',
    prevEl: '.news-slider-prev'
  },

  on: {

    init: function (swiper) {
      this.$el.find('.swiper-slide-active .r1-slide-sub-box').addClass('active');
      this.$el.find('.swiper-slide-active h3').addClass('active');
    },
    slideNextTransitionStart: function (swiper) {

    },
    slideChangeTransitionEnd: function () {
      this.slides.find('.r1-slide-sub-box').removeClass('active');
      this.slides.find('h3').removeClass('active');
      this.slides.eq(this.activeIndex).find('.r1-slide-sub-box').addClass('active');
      this.slides.eq(this.activeIndex).find('h3').addClass('active');
    },

  },

});




// var r1ThumbSwiper = new Swiper('.r1-show-thumbs', {
//   direction: 'vertical',
//   slidesPerView: 3,
//   spaceBetween: 20,
//   centeredSlides: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//   on: {
//     slideChangeTransitionEnd: function (swiper) {
//       let index = this.realIndex;
//       setContent(index, 'thumbs');
//       r1Topswiper.slideTo(this.activeIndex, 1000, false);
//     },
//   }
// });
var r1Topswiper = new Swiper('.r1-show-top', {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  on: {
    slideChangeTransitionEnd: function (swiper) {
      let index = this.realIndex //当前索引
      setContent(index, 'top')
    }
  }
});

function setContent(index, type) {
  let r1Slide = document.querySelectorAll('.rb-slide-content .swiper-slide');
  let title = r1Slide[index].getAttribute('data-title'); //获取当前Item标题
  let desc = r1Slide[index].getAttribute('data-desc'); //获取当前Item描述
  let bg = r1Slide[index].getAttribute('data-bg') //获取当前Item背景
  let titleEl = document.getElementById('rbSlideTitle') //标题元素
  let descEl = document.getElementById('rbSlideDesc') //描述元素
  let bgEl = document.getElementById('rbSlideBg') //背景元素
  titleEl.innerText = title;
  descEl.innerText = desc;
  bgEl.setAttribute('src', bg)
}



var r1ProductShow2 = new Swiper('.r1-product-show2', {
  slidesPerView: 'auto',
  spaceBetween: 25,
  loop: true,
  on: {

    init: function (swiper) {
      this.slides.eq(this.activeIndex).find('.text-content').addClass('active');
    },
    slideNextTransitionStart: function (swiper) {

    },
    slideChangeTransitionStart: function () {
      this.slides.find('.text-content').removeClass('active');

      this.slides.eq(this.activeIndex).find('.text-content').addClass('active');
    },

  },
});


var r1SlideSwiper222 = new Swiper('.s1-slide-content', {
  slidesPerView: 1.57,

  spaceBetween: 33,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    pauseOnMouseEnter: true,
  },



});

if (r1SlideSwiper222.el != undefined) {
  r1SlideSwiper222.el.onmouseover = function () {
    r1SlideSwiper222.autoplay.stop();
  }
  r1SlideSwiper222.el.onmouseout = function () {
    r1SlideSwiper222.autoplay.start();
  }
}




var r1Params = new Swiper('.r1-params-slide', {
  slidesPerView: isPhone == 'web' ? 2.1 : 1,
  spaceBetween: isPhone == 'web' ? 300 : 0,
  parallax: true,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.news-slider-next',
    prevEl: '.news-slider-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  observeParents: true,
  observer: true,
});

if (r1Params.el != undefined) {
  //鼠标覆盖停止自动切换与隐藏前进后退按钮
  r1Params.el.onmouseover = function () {
    r1Params.navigation.$nextEl.removeClass('hide');
    r1Params.navigation.$prevEl.removeClass('hide');
  }
  //鼠标覆盖停止自动切换与隐藏前进后退按钮
  r1Params.el.onmouseout = function () {
    r1Params.navigation.$nextEl.addClass('hide');
    r1Params.navigation.$prevEl.addClass('hide');
  }
}


var r1Params2 = new Swiper('.r1-params-slide2', {
  slidesPerView: isPhone == 'web' ? 2.1 : 1,
  spaceBetween: isPhone == 'web' ? 300 : 0,
  parallax: true,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.news-slider-next',
    prevEl: '.news-slider-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

if (r1Params2.el != undefined) {
  //鼠标覆盖停止自动切换与隐藏前进后退按钮
  r1Params2.el.onmouseover = function () {
    r1Params2.navigation.$nextEl.removeClass('hide');
    r1Params2.navigation.$prevEl.removeClass('hide');
  }
  //鼠标覆盖停止自动切换与隐藏前进后退按钮
  r1Params2.el.onmouseout = function () {
    r1Params2.navigation.$nextEl.addClass('hide');
    r1Params2.navigation.$prevEl.addClass('hide');
  }
}

var r1Params3 = new Swiper('.r1-params-slide3', {
  slidesPerView: isPhone == 'web' ? 1.2 : 1,
  spaceBetween: isPhone == 'web' ? 400 : 0,
  parallax: true,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.news-slider-next',
    prevEl: '.news-slider-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

if (r1Params3.el != undefined) {
  //鼠标覆盖停止自动切换与隐藏前进后退按钮
  r1Params3.el.onmouseover = function () {
    r1Params3.navigation.$nextEl.removeClass('hide');
    r1Params3.navigation.$prevEl.removeClass('hide');
  }
  //鼠标覆盖停止自动切换与隐藏前进后退按钮
  r1Params3.el.onmouseout = function () {
    r1Params3.navigation.$nextEl.addClass('hide');
    r1Params3.navigation.$prevEl.addClass('hide');
  }
}

function getLanguage(pic, title) {
  $('.header-language .current').find('img').attr('src', pic)
  $('.header-language .current-text').text(title)
}

var slideSwiper = new Swiper('.ind-slideshow', {
  autoplay: {
    delay: 2000,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

var indexComment = new Swiper('.index-comment-container', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    slideChangeTransitionEnd: function () {
      $('.comment-picture img').eq(this.activeIndex).addClass('on').siblings().removeClass('on')
    },
  },
});